import axios from "../../plugins/axios";

const state = {
    packageQuantity: 0,
};

const mutations = {
    setPackageQuantity(state, data) {
        state.packageQuantity = data;
    },
};

const getters = {};

const actions = {
    fetchPackageQuantity({ commit }) {
        // 获取店铺列表
        axios
            .post("payment/api/v1/Vas/GetQuantity", {
                ValueAddedServicesType: 4,
            })
            .then(({ code, result }) => {
                if (code === 200) {
                    commit("setPackageQuantity", result[0].quantity);
                }
            });
    },
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
